import { OLD_CONTENT_TYPES } from "./CommonConstants";

/**
 * `status` values the publish mutations accept. The two content families disagree on the word for
 * "unpublish": fixed types (`authoring_publishContent`) take `depublish`, schema-based types
 * (`authoring_publishSchemaContent`) take `unpublish`. Verified against kiwi, KIWI-6576.
 */
export const SCHEDULE_STATUS = {
  PUBLISH: "publish",
  DEPUBLISH: "depublish",
  UNPUBLISH: "unpublish",
} as const;

/**
 * True for the legacy "fixed" content types, which publish through `authoring_publishContent`
 * keyed by `page`. Everything else is schema-based and publishes through
 * `authoring_publishSchemaContent` keyed by `document_name`. Case-insensitive.
 */
export const isFixedContentType = (contentType?: string | null): boolean => {
  if (!contentType) return false;
  const wanted = contentType.toLocaleLowerCase();
  return OLD_CONTENT_TYPES.some((item) => item.toLocaleLowerCase() === wanted);
};

/** The `status` that unpublishes an item of the given content type. */
export const getUnpublishStatus = (contentType?: string | null): string =>
  isFixedContentType(contentType) ? SCHEDULE_STATUS.DEPUBLISH : SCHEDULE_STATUS.UNPUBLISH;
